const normalizeUrl = (value) => {
  if (!value || typeof value !== 'string') {
    return '';
  }

  return value.trim().replace(/\/$/, '');
};

const rawBackendUrl = normalizeUrl(process.env.REACT_APP_API_BASE_URL);

if (!rawBackendUrl && process.env.NODE_ENV === 'development') {
  console.warn(
    'REACT_APP_API_BASE_URL is not set. Please define it in your .env file so API calls know which backend to use.'
  );
}

if (!rawBackendUrl) {
  throw new Error(
    'Missing REACT_APP_API_BASE_URL environment variable. Set it in your .env file (e.g., REACT_APP_API_BASE_URL=https://your-backend/api).'
  );
}

export const BACKEND_API_BASE_URL = rawBackendUrl;

export const buildApiUrl = (path = '') => {
  if (!path) {
    return BACKEND_API_BASE_URL;
  }

  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return `${BACKEND_API_BASE_URL}${normalizedPath}`;
};
